import { useEffect } from 'react';
import { Routes, Route } from 'react-router';
import usePermissions from '../hooks/usePermissions';
import MainComponent from '../components/MainComponent/MainComponent';
import PrivateRoutes from './PrivateRoutes';
import NotAuthorized from '../components/Not-Authorised/NotAuthorised';
import { Permissions } from '../constants';
import Submissions from '../pages/submissions';
import Dashboard from '../pages/dashboard';
import useLanguagePackTermsetModuleLanguagePack from '../hooks/useLanguagePackTermsetModule';
import { useAppSelector } from '../redux/Store';
import { useDispatch } from 'react-redux';
import {
  setAuditState,
  setIsGalleryPanelOpen,
  setIsReadOnly,
} from '../redux/reducer/contextIdReducer';

const InspectRoutes = () => {
  const permissions = useAppSelector(
    (state) => state.permissions.permissionData
  );

  const { getPermission } = usePermissions();
  const { getLanguagePackTermsetModule } =
    useLanguagePackTermsetModuleLanguagePack();
  const dispatch = useDispatch();

  useEffect(() => {
    const isAuthenticatedOnDev = () => {
      const isIframe = globalThis.self !== globalThis.top;
      if (!isIframe) {
        getPermission();
        getLanguagePackTermsetModule();
        dispatch(setAuditState(false));
        dispatch(setIsGalleryPanelOpen(false));
        dispatch(setIsReadOnly(true));
      }
    };

    isAuthenticatedOnDev();
  }, [dispatch, getPermission, getLanguagePackTermsetModule]);

  return (
    <Routes>
      {/* Home Route (Inspector Permission Required) */}
      <Route
        path='/home'
        element={
          <PrivateRoutes requiredPermissions={[Permissions.IS_INSPECTOR]}>
            <Dashboard />
          </PrivateRoutes>
        }
      />
      {/* Audit View Route (Audit Permission Required) */}
      <Route
        path='non-audit-view'
        element={
          <PrivateRoutes requiredPermissions={[Permissions.CAN_VIEW_AUDIT]}>
            <MainComponent />
          </PrivateRoutes>
        }
      />

      {/* Submissions Route (Submissions Permission Required) */}
      <Route
        path='submissions/:orderNumber/:propertyLoanId'
        element={
          <PrivateRoutes
            requiredPermissions={[Permissions.CAN_VIEW_SUBMISSIONS]}
          >
            <Submissions />
          </PrivateRoutes>
        }
      />

      {/* Not Authorized Route */}
      <Route path='/not-authorized' element={<NotAuthorized />} />
    </Routes>
  );
};

export default InspectRoutes;
